<template>
  <div @click="click" class="column-multline" style="font-weight: normal">
    <span class="bold">{{row[column.field[0]].descricao}}</span>
    <span class="small-title">{{row[column.field[1]].descricao}}</span>
    <span class="small-title" >Paciente: {{row[column.field[2]].nome}}</span>
    <span class="small-title" v-if="exibeTipoServico">{{row[column.field[0]][column.field[3]].descricao}}</span>
  </div>
</template>
<script>
export default {
  name: 'MultiFieldItem',
  props: ['column', 'row'],
  computed: {
    exibeTipoServico () {
      return this.row[this.column.field[0]][this.column.field[3]] !== undefined
    }
  },
  methods: {
    click () {
      if (this.column && this.column.click) {
        this.column.click(this.row)
      }
      this.$emit('click', this.row)
    }
  }
}
</script>
<style lange="less">
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@200&family=Open+Sans:wght@300&display=swap');
.small-title {
  font-family: 'Open Sans', sans-serif;;
  font-size: 11px;
  text-align: left;
  line-height: 15px;
  color: #333333;
  font-weight: 400;
  display: block;
}
.bold {
  font-family: "Open Sans", SansSerif;
  color: #333333;
  opacity: 1;
  font-weight: 600;
}
</style>
